import { R } from '@core/utils/r';
import { Endpoint } from '@business/api/endpoint';
import { CompanyId } from '@business/entities/companies';
import { TMTimeTrackingId, TMTimeTrackingResponse } from '@business/entities/tm/TMTimeTrackingResponse';
import { TMTimeTrackingFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/AddEditTMTimeTrackingOverlay/AddEditTMTimeTrackingOverlay';
import { TimeMaterialId } from '@business/entities/tm';

export function fetchTimeTrackings(orderId?: TimeMaterialId, isPublic = false) {
  if (isPublic) {
    return Endpoint.get<TMTimeTrackingResponse[]>(`@gc/public/tm-time-tracking`, { params: R.objectCompact({ orderId }) });
  }
  return Endpoint.get<TMTimeTrackingResponse[]>(`@gc/tm-time-tracking`, { params: R.objectCompact({ orderId }) });
}
export function createTimeTracking(data: Partial<TMTimeTrackingFormData>) {
  return Endpoint.post<TMTimeTrackingResponse>(`@gc/tm-time-tracking`, { data });
}

export function updateTimeTracking(id: TMTimeTrackingId, data: Partial<TMTimeTrackingFormData>) {
  return Endpoint.patch<TMTimeTrackingResponse>(`@gc/tm-time-tracking/${id}`, { data });
}

export function deleteTimeTracking(id: TMTimeTrackingId) {
  return Endpoint.delete<void>(`@gc/tm-time-tracking/${id}`);
}

export function fetchTimeTracking(id: TMTimeTrackingId) {
  return Endpoint.get<TMTimeTrackingResponse>(`@gc/tm-time-tracking/category/${id}`);
}
